import Cisco from "public/cyberSecTechStack/cisco.png";
import Fortinet from "public/cyberSecTechStack/fortinet.png";
import PaloAlto from "public/cyberSecTechStack/paloalto.png";
import ninjaRmm from "public/cyberSecTechStack/NinjaRMM.png";
import Sophos from "public/cyberSecTechStack/sophos.png";

export const CYBER_SEC_TECH_STACK_CONSTANTS = {
  title: "Our Security Stack",
  list: [
    { name: "Cisco", logo: Cisco },
    { name: "PaloAlto", logo: PaloAlto },
    { name: "Fortinet", logo: Fortinet },
    { name: "Sophos", logo: Sophos },
    { name: "NinjaRMM", logo: ninjaRmm },
  ],
};
